<mat-card-subtitle>
    <p style="margin: 0%; font-weight: 600;">Current Location:</p>{{location}}
</mat-card-subtitle>
<google-map height="300px" width="100%" [center]="center" [zoom]="zoom">
    <map-marker [position]="markerPosition"></map-marker>
</google-map>